import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom"; // Import Link for internal navigation


function ActivitiesCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.text}</Card.Text>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Card.Text>{props.text1}</Card.Text>
        <Button variant="primary">
          <Link to={props.ghLink} style={{ color: "white", textDecoration: "none" }}>
            {props.isBlog ? "Blog" : "View More"}
          </Link>
        </Button>
       

      </Card.Body>
    </Card>
  );
}
export default ActivitiesCards;
